import { z } from 'zod'

import {
  PageResponseSchema,
  Pagination,
} from '@/modules/expiring-fans/service/expiring-fans-service.ts'
import { apiClient } from '@/utils/axios.ts'

export interface SentMessageFilters {
  userId?: number
  message?: string
  fanIds?: number[]
  listIds?: string[]
  messageType?: string
}

const SentMessageSchema = z.object({
  id: z.number(),
  message: z.string(),
  senderId: z.number().nullish(),
  senderName: z.string().nullish(),
  fanId: z.number(),
  fanName: z.string().nullish(),
  sentAt: z.string(),
  removed: z.boolean(),
  tag: z.string(),
  profilePicture: z.string().nullish(),
  onlyfansId: z.number(),
})

export type SentMessage = z.infer<typeof SentMessageSchema>

const SenderSchema = z.object({
  senderId: z.number(),
  senderName: z.string(),
})

export type Sender = z.infer<typeof SenderSchema>

const SentMessageResultSchema = PageResponseSchema(SentMessageSchema)

export type SentMessageResult = z.infer<typeof SentMessageResultSchema>

async function getSentMessages(
  creatorId: number,
  sortDirection: 'ASC' | 'DESC',
  filter: SentMessageFilters,
  pagination?: Pagination,
): Promise<SentMessageResult> {
  const response = await apiClient.get(`tracking/${creatorId}/messages/sent`, {
    params: {
      ...pagination,
      ...filter,
      sortDirection,
    },
  })

  return SentMessageResultSchema.parse(response.data)
}

async function getAllSenders(creatorId: number): Promise<Sender[]> {
  const response = await apiClient.get(`tracking/${creatorId}/messages/senders`)

  return z.array(SenderSchema).parse(response.data)
}

export const messageHistoryService = {
  getSentMessages,
  getAllSenders,
}
